import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .cls-1 {\n        stroke: #00b2e3;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n        stroke-width: 2.5px;\n      }\n\n      .cls-2, .cls-3 {\n        stroke: #002d74;\n      }\n\n      .cls-3 {\n        stroke-linejoin: round;\n      }\n    " }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "m25.7,43.69v-4.61c0-1.77-1.43-3.2-3.2-3.2s-3.2,1.43-3.2,3.2v4.61"
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "cls-2",
			points: "33.28 28.6 35.28 43.69 9.73 43.69 11.73 28.6"
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "cls-2",
			points: "12.48 22.92 13.73 13.5 31.28 13.5 32.53 22.92"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-3",
			d: "m25.26,28.6h-15.65c-3.42,0-6.44-1.63-8.36-4.16,1.27.54,2.67.85,4.15.85,2.53,0,4.83-.89,6.64-2.37h14.87s6.03,0,6.03,0c1.81,1.48,4.11,2.37,6.64,2.37,1.48,0,2.88-.31,4.15-.85-1.92,2.53-4.95,4.16-8.36,4.16h-8.46s-1.64,0-1.64,0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-3",
			d: "m36.29,10.6c-6.26,0-11.6-3.87-13.79-9.34-2.19,5.47-7.54,9.34-13.79,9.34-.73,0-1.45-.07-2.15-.17,1.21,1.85,3.29,3.08,5.66,3.08h20.56c2.37,0,4.46-1.23,5.66-3.08-.7.1-1.42.17-2.15.17Z"
		})
	]
});
export default SvgIcon;
